module.exports = __webpack_public_path__ + "static/media/26_B.bab6570d.png";